document.addEventListener('DOMContentLoaded', function() {
    const segments  = document.querySelectorAll('.segment');
    const infoTitle = document.getElementById('info-title');
    const infoText  = document.getElementById('info-text');
    const infoCta   = document.getElementById('info-cta');
    const infoLogos = document.getElementById('info-logos');
    let selectedIndex = -1;
    const isMobile = window.matchMedia('(max-width: 720px)').matches;
    // Fade helper for normal elements
    function fadeUpdate(element, newHTML) {
        element.classList.add('fade-out');
        setTimeout(() => {
            element.innerHTML = newHTML;
            element.classList.remove('fade-out');
            element.classList.add('fade-in');
            setTimeout(() => {
                element.classList.remove('fade-in');
            }, 300);
        }, 300);
    }

    // Fade helper for CTA text only (safe)
    function fadeButtonText(button, text) {
        button.classList.add('fade-out');
        setTimeout(() => {
            button.textContent = text;
            button.classList.remove('fade-out');
            button.classList.add('fade-in');

            setTimeout(() => {
                button.classList.remove('fade-in');
            }, 300);
        }, 300);
    }

    function updateInfo(index) {
        index = parseInt(index);
        if (index === selectedIndex) {return;}
        selectedIndex = index;
        segments.forEach(s => s.classList.remove('active'));
        const activeSeg = segments[index];
        activeSeg.classList.add('active');
        fadeUpdate(infoTitle, activeSeg.dataset.title);
        fadeUpdate(infoText, activeSeg.querySelector('.desc-html').innerHTML);
        fadeUpdate(infoLogos, activeSeg.querySelector('.logos-html').innerHTML);
        // CTA SAFE UPDATE
        fadeButtonText(infoCta, activeSeg.dataset.ctaLabel);
        infoCta.href  = activeSeg.dataset.cta || '#';
        infoCta.title = activeSeg.dataset.ctaTitle || '';
    }
    updateInfo(0);
    segments.forEach(seg => {
        if (!isMobile) {
            seg.addEventListener('mouseenter', function() {
                updateInfo(this.dataset.index);
            });
        }
        seg.addEventListener('click', function() {
            updateInfo(this.dataset.index);
        });
    });
});
